// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","hamburger":"header_hamburger__hFeUL","nav":"header_nav__QGzOh","logo":"header_logo__wLirW","img":"header_img__ePQ5u","icon":"header_icon__GiOHU"};